import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageInstance } from "../../utils/storage";

const Protected = () => {
  const auth = localStorageInstance.getItem("token");

  return auth ? <Navigate to="/my_leagues" /> : <Outlet />;
};

export default Protected;
